import React, { useEffect, useMemo } from 'react'
import { useRetorikStore } from '../Contexts/RetorikContext'
import { useViewStore } from '../Contexts/ViewContext'
import { useSpeechStore } from '../Contexts/SpeechContext'
import { useWidgetStore } from '../Contexts/WidgetContext'

import { ContainerParent, DeviceType, Mode } from '../../models/enums'

import Background from '../Common/Background'
import OldUserRequest from '../AnswerPanel/OldUserRequest'
import UserRequest from '../AnswerPanel/UserRequest'
import Logo from '../Common/Logo'
import OldBotResponse from '../AnswerPanel/OldBotResponse'
import BotResponse from '../AnswerPanel/BotResponse'
import RetorikLogo from '../Common/RetorikLogo'
import SubViews from './SubViews'
import ConversationPanel from '../AnswerPanel/ConversationPanel'
import OldMenuDisplayer from '../Menu/MenuDisplayer'
import MenuDisplayer from '../Menus/MenuDisplayer'
import ExtendIcon from '../Icons/Miscellaneous/ExtendIcon'

interface HomeViewProps {
  externalComponents?: Array<{ name: string; component: JSX.Element }>
}

const HomeView = ({ externalComponents }: HomeViewProps): JSX.Element => {
  const openWidget = useWidgetStore((state) => state.actions.openWidget)
  const currentLayout = useRetorikStore((state) => state.currentLayout)
  const loaderClosed = useRetorikStore((state) => state.loaderClosed)
  const configuration = useRetorikStore((state) => state.configuration)
  const mode = useSpeechStore((state) => state.mode)
  const isMobile = useViewStore((state) => state.isMobile)
  const currentDeviceType = useViewStore((state) => state.currentDeviceType)
  const configurations = useViewStore((state) => state.configurations)
  const setDisplayControls = useViewStore((state) => state.actions.setDisplayControls)
  const setLayout = useRetorikStore((state) => state.actions.setLayout)

  const displayData = useMemo(() => {
    return configurations.views.home
  }, [configurations])

  useEffect(() => {
    setDisplayControls(!configuration.hideControls)
  }, [])

  const extendButtonHandler = () => {
    setLayout(ContainerParent.widget)
    openWidget()
  }

  return (
    <React.Fragment>
      {!!configuration.allowSwitchLayout && currentLayout !== ContainerParent.widget && (currentDeviceType === DeviceType.widgetLandscape || currentDeviceType === DeviceType.widgetBorne) && (
        <button
          onClick={extendButtonHandler}
          aria-label='Minimize'
          className='rf-absolute rf-z-exitwidget rf-flex rf-top-1 rf-p-1 rf-bg-truewhite rf-border rf-border-trueblack rf-rounded-lg rf-right-10'
        >
          <ExtendIcon className='rf-h-4 rf-w-4' color='#000000' extended={true} />
        </button>
      )}
      {/* Background */}
      <Background config={displayData.background} />

      {/* Logo */}
      {configuration?.logo && (!isMobile || (isMobile && mode !== Mode.text)) && <Logo />}

      {/* Activity input / output */}
      {configuration?.answerpanel !== false && loaderClosed && (
        <React.Fragment>
          {!isMobile && (configuration.useOldRemote ? <OldUserRequest /> : <UserRequest />)}
          {mode === Mode.vocal ? configuration.useOldRemote ? <OldBotResponse /> : <BotResponse /> : <ConversationPanel />}
        </React.Fragment>
      )}

      {/* Menus */}
      {configuration.useOldRemote ? <OldMenuDisplayer hideMenu={configuration?.hideMenu} /> : <MenuDisplayer hideMenu={configuration?.hideMenu} />}

      {/* Miscellaneous */}
      {loaderClosed && <SubViews externalComponents={externalComponents} />}

      {/* Retorik Logo on right bottom */}
      {!configuration?.hideRetorikLogo && <RetorikLogo />}
    </React.Fragment>
  )
}

export default HomeView
